/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	import Obj = alm.util.Obj;

	export class ActivityLandmark {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(json:object) {
			const landmark:object = json['landmark'];

			this.type = landmark['landmark_type_id'];
			this.name = landmark['name'];

			const coordinate:number[] = landmark['coord'];
			this.hasCoordinate = coordinate !== null;
			if (this.hasCoordinate) {
				this.position = new LatLng(coordinate[1], coordinate[0]);
				this.altitude = Obj.get(landmark, 'altitude', -1);
			} else {
				this.position = null;
				this.altitude = null;
			}

			this.enteredAt = json['entered_at'] * 1000;
			this.leftAt = json['left_at'] * 1000;
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public getType():number {
			return this.type;
		}

		public getName():string {
			return this.name;
		}

		public getHasCoordinate():boolean {
			return this.hasCoordinate;
		}

		public getPosition():LatLng {
			return this.position;
		}

		public getAltitude():number {
			return this.altitude;
		}

		public getEnteredAt():number {
			return this.enteredAt;
		}

		public getLeftAt():number {
			return this.leftAt;
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private type:number;
		private name:string;

		private hasCoordinate:boolean;
		private position:LatLng;
		private altitude:number;

		private enteredAt:number;
		private leftAt:number;
	}
}
